import React from "react";
import { DoubleTagIcon } from "../../utils/miscIcons";

const TotalSavings = ({ type, savings, label }) => {
  switch (type) {
    case "boxed":
      return (
        <div className="savings__container">
          <div className="savings__label">
            <DoubleTagIcon /> {label && label}
          </div>
          <div>{savings && savings}</div>
        </div>
      );

    default:
      return (
        <div className={`orderOverviewDrawerV3__savingsLabel__cont__bottom`}>
          <div className="orderOverviewDrawerV3__savingsLabel">{label && label}</div>
          <div className="orderOverviewDrawerV3__savingsLabel">-{savings && savings}</div>
        </div>
      );
  }
};

export default TotalSavings;
